module.exports = __webpack_public_path__ + "static/img/logo-localiza.c8703272.svg";